import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="theme-footer-five mt-130 md-mt-100">
      <div className="inner-container">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-4">
              <div className="logo">
                <Link to="/">
                  {/* <img src="./assets/images/logo/cybernate-logo.svg" alt="Cybernate" /> */}
                  <h1 className="title" style = {{fontSize: 25, fontWeight: '500'}}>Cybernate</h1>
                </Link>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="title">Connect With Us</div>
              <ul className="d-flex justify-content-center social-icon">
                <li>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-linkedin" aria-hidden="true" />
                  </a>
                </li>
                {/* <li>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-twitter" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-github" aria-hidden="true" />
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="col-lg-4">
              <div className="title">Questions? We're here to help.</div>
              <div className="text-center">
                <a href="mailto:support@cybernate.ai" className="email">
                  support@cybernate.ai
                </a>
              </div>
            </div>
          </div>
          
          {/* Legal Links */}
          <div className="row mt-5">
            <div className="col-12">
              <div className="footer-nav text-center">
                <ul className="d-flex justify-content-center flex-wrap">
                  <li><Link to="/legal">Privacy Policy</Link></li>
                  <li className="mx-3">|</li>
                  <li><Link to="/legal">Terms of Service</Link></li>
                  {/* <li className="mx-3">|</li> */}
                  {/* <li><Link to="/data-security">Data Security</Link></li>
                  <li className="mx-3">|</li>
                  <li><Link to="/contact">Contact Us</Link></li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
        <p className="copyright">Copyright © {new Date().getFullYear()} Cybernate, Inc. All rights reserved.</p>
    </footer>
  );
}

export default Footer;

